import React from 'react';

import { Card, Collapse, createStyles } from '@mantine/core';

import SectionBody from './SectionBody';
import SectionHeader from './SectionHeader';
import { useWorkoutSection } from './useWorkoutSection';
import { WorkoutSectionData, WorkoutSectionFormHandle } from '../../../../../forms/workoutBuilder/types';

interface WorkoutSectionProps {
  section: WorkoutSectionData;
  index: number;
  form: WorkoutSectionFormHandle;
  onDelete: (index: number) => void;
  onDuplicate: (index: number) => void;
  canDelete: boolean;
}

const useStyles = createStyles(theme => ({
  card: {
    marginBottom: theme.spacing.md,
  },
}));

const WorkoutSection = ({
  section,
  index,
  form,
  onDelete,
  onDuplicate,
  canDelete,
}: WorkoutSectionProps): JSX.Element => {
  const { classes } = useStyles();
  const {
    getSectionTitle,
    handleAddMovement,
    handleMovementChange,
    handleMovementScoringChange,
    handleDeleteMovement,
    disableScoreEntireSection,
    enableSectionAsOneOff,
    enableSectionAsKeptBenchmark,
    revertToOneOff,
    linkBenchmark,
    unlinkBenchmark,
    handleToggleLevel,
    sectionOpened,
    toggleSection,
  } = useWorkoutSection(form, index, section);

  return (
    <Card className={classes.card} p='md' radius='md' withBorder>
      <SectionHeader
        sectionTitle={getSectionTitle()}
        sectionOpened={sectionOpened}
        onToggle={toggleSection}
        onDuplicate={() => onDuplicate(index)}
        onDelete={() => onDelete(index)}
        canDelete={canDelete}
        sectionId={section.id}
      />
      <Collapse in={sectionOpened}>
        <SectionBody
          form={form}
          index={index}
          section={section}
          onAddMovement={handleAddMovement}
          onMovementChange={handleMovementChange}
          onMovementScoringChange={handleMovementScoringChange}
          onDeleteMovement={handleDeleteMovement}
          onDisableScoreEntireSection={disableScoreEntireSection}
          onEnableSectionAsOneOff={enableSectionAsOneOff}
          onEnableSectionAsKeptBenchmark={enableSectionAsKeptBenchmark}
          onRevertToOneOff={revertToOneOff}
          onLinkBenchmark={linkBenchmark}
          onUnlinkBenchmark={unlinkBenchmark}
          onToggleLevel={handleToggleLevel}
        />
      </Collapse>
    </Card>
  );
};

export default WorkoutSection;
